import Cookies from 'js-cookie/src/js.cookie';

const cookieWarning = () => {
  if (Cookies.get('cookieMonsterSuppressed') !== 'true') {
    // Search for both the theme default and potential variations
    const cookieWarningElem =
      document.querySelector('[data-cookie-warning]') ||
      document.querySelector('.cookie-warning') ||
      document.querySelector('#cookie-warning');

    if (!cookieWarningElem) {
      // Don't log error here as it might be handled by an external app (Pandectes)
      return;
    }

    cookieWarningElem.classList.remove('hide');

    const btn =
      cookieWarningElem.querySelector('[data-cookie-warning-btn]') ||
      cookieWarningElem.querySelector('.cookie-warning__btn');

    if (btn) {
      btn.addEventListener('click', e => {
        // Prevent Voyado from tracking this specific click
        // as it will refresh the page or change state
        e.stopPropagation();

        cookieWarningElem.classList.add('hide');
        Cookies.set('cookieMonsterSuppressed', 'true', { expires: 31 });
      });
    }
  }
};

export default cookieWarning;
